// @flow strict

import * as React from 'react';
import cx from 'classnames';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';
import FormattedContent from '../../internal/FormattedContent';
import PageContentBlock from '../../internal/PageContentBlock';
import ResponsiveImage from '../../internal/ResponsiveImage';
import { Link } from '../../internal/Button';
import type { InlineRichText } from '../../internal/types';
import { Columns } from '../../internal/Columns';

export type ColumnType = {|
  image: string,
  alt: string,
  title?: string,
  children: InlineRichText,
  ctaText?: string,
  ctaHref?: string,
|};

type ColorType = 'Black';

const Column = (props: {
  ...ColumnType,
  color?: ColorType,
  singleColumn: boolean,
  isDarkBackground: boolean,
}) => {
  const imageClassName = cx(
    styles.imageContainer,
    props.color && styles[`is${props.color}`],
    props.color && styles.isColor,
  );
  return (
    <div className={cx(styles.col, props.singleColumn && styles.isSingle)}>
      {props.image && (
        <div className={imageClassName}>
          <ResponsiveImage
            className={styles.image}
            src={props.image}
            alt={props.alt}
            defaultSize={props.color ? { width: 45, height: 45 } : { width: 288, height: 120 }}
          />
        </div>
      )}
      {props.title && <h2 className={styles.colTitle}>{props.title}</h2>}
      <FormattedContent isDarkBackground={props.isDarkBackground} className={styles.text}>
        {props.children}
      </FormattedContent>
      {props.ctaText && props.ctaHref && (
        <Link variant="Underline" href={props.ctaHref} className={styles.button}>
          {props.ctaText}
        </Link>
      )}
    </div>
  );
};

const backgroundMap = {
  Low: 'Featured',
  Medium: 'Default',
  High: 'DefaultContrast',
  Dark: 'Dark',
};

type PropTypes = {|
  title?: string,
  subtitle?: string,
  items: Array<ColumnType>,
  background: 'Low' | 'Medium' | 'High' | 'Dark',
  color: boolean,
  singleColumn: boolean,
|};

const MultiColumn = (props: PropTypes) => (
  <PageContentBlock
    background={backgroundMap[props.background]}
    title={props.title}
    intro={props.subtitle}
  >
    <div>
      <Columns columns={props.singleColumn ? 1 : 4} centerColumns fitBestColumns>
        {props.items.map((item, index) => (
          /* eslint-disable react/no-array-index-key */
          <Column
            key={index}
            {...item}
            color={props.color ? 'Black' : undefined}
            singleColumn={props.singleColumn}
            isDarkBackground={props.background === 'Dark'}
          />
          /* eslint-enable react/no-array-index-key */
        ))}
      </Columns>
    </div>
  </PageContentBlock>
);

MultiColumn.defaultProps = {
  color: false,
  background: 'Low',
  singleColumn: false,
};

export default MultiColumn;
